import React, { createContext } from 'react';

export const ContentExportContext = createContext(null);

const ContentExportContextProvider = ({
  children,
  isLiveExport
}: {
  children: React.ReactNode;
  isLiveExport: boolean;
}) => {
  return (
    <ContentExportContext.Provider
      value={{
        isLiveExport
      }}
    >
      {children}
    </ContentExportContext.Provider>
  );
};

export default ContentExportContextProvider;
